import React, { memo } from "react";
import Logo from "../../../assets/images/wifi-attendance.svg";

const LogoBlock = ({ collapsed, companyLogo, onLogoClick }) => {
  const src = companyLogo || Logo;

  return (
    <button
      type="button"
      className={
        collapsed ? "sb-sidebar__brand sb-sidebar__brand--mini" : "sb-sidebar__brand"
      }
      onClick={onLogoClick}
      aria-label="Go to home"
    >
      <img
        src={src}
        alt="Logo"
        className="sb-sidebar__brand-img"
        onError={(e) => {
          e.target.src = Logo;
        }}
      />
    </button>
  );
};

export default memo(LogoBlock);
